import React, { createContext, useState, useEffect } from "react";
import { ShowToast, Severty } from "../helper/toast";
import { settingsAPI, subscriptionAPI } from "../services/api";

export const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  //get subscriptions plans
  const getSubscriptions = async () => {
    try {
      const response = await subscriptionAPI.loadSubscriptionPlans();
      return response;
    } catch (error) {
      throw error;
    }
  };

  //Get My Subscription
  const getMyPlan = async () => {
    try {
      const response = await subscriptionAPI.getMyPlan();
      return response;
    } catch (error) {
      throw error;
    }
  };

  //Purchase plan
  const purchasePlan = async (data) => {
    try {
      const response = await subscriptionAPI.purchasePlan(data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // Canel Subscription
  const cancelSubscription = async () => {
    try {
      const response = await subscriptionAPI.cancelPlan();
      return response;
    } catch (error) {
      throw error;
    }
  };

  return (
    <SubscriptionContext.Provider
      value={{
        getSubscriptions,
        getMyPlan,
        purchasePlan,
        cancelSubscription,
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};

// Custom hook to use the wallet context
export const useSubscription = () => {
  const context = React.useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error(
      "useSubscription must be used within a Subscription Provider"
    );
  }
  return context;
};
